import { render } from "./ProcessImageTab.vue?vue&type=template&id=00ed5df6&scoped=true"
import script from "./ProcessImageTab.vue?vue&type=script&lang=js"
export * from "./ProcessImageTab.vue?vue&type=script&lang=js"

import "./ProcessImageTab.vue?vue&type=style&index=0&id=00ed5df6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ed5df6"]])

export default __exports__